module.exports = __webpack_public_path__ + "img/accessory_shirt_04.81d35b0a.svg";